import React from 'react'

export default function HeadphoneIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="106" height="91" viewBox="0 0 106 91" fill="none">
            <path d="M104 53H92.6667C86.4074 53 81.3333 58.0741 81.3333 64.3333V75.6667C81.3333 81.9259 86.4074 87 92.6667 87C98.9259 87 104 81.9259 104 75.6667V53ZM104 53C104 24.8335 81.1665 2 53 2C24.8335 2 2 24.8335 2 53M2 53V75.6667C2 81.9259 7.07411 87 13.3333 87C19.5926 87 24.6667 81.9259 24.6667 75.6667V64.3333C24.6667 58.0741 19.5926 53 13.3333 53H2Z" stroke="#B5B5B5" strokeWidth="2.66667" strokeLinecap="square" />
            <path d="M104 49.4062V72.0729C104 83.4063 100.222 89.0729 92.6664 89.0729C85.1108 89.0729 75.6663 89.0729 64.333 89.0729" stroke="#B5B5B5" strokeWidth="2.66667" strokeLinecap="square" />
        </svg>
    )
}
